import request from 'src/network';

const apiPath = '/api/ai_agent/vectorstore';

export function getVectorStoreService() {
    return request.GET<string>(apiPath);
}

export function getVectorStoreServiceV2() {
    return request.GET<string>('/api/ai_agent_v2/agent/vectorstore');
}